export default (data, page, subpage) => {
  const info = data.datalist;
  const pagetitle = subpage.replace("-", " ");
  let action = "";
  let action_target = "";

  switch (subpage) {
    case "all-users":
      action = "suspend";
      action_target = "suspend-account";
      break;
    case "new-users":
      action = "resend confirmation";
      action_target = "confirmation-email";
      break;
  }
  return `
    <h4 class="page-title">List : ${pagetitle} (${data.datalist.length})</h4>
        <div class="inner-container flex-container">
        ${info
          .map((usr) => {
            return `<div class="tb-user">
                <div class="tb-user__image circle-image circle-image--lg">
                    <img src="${usr.photo}" class="user-image circle-image__item" />
                </div>
                <div class="tb-user__usr">
                    <a href="https://thisbit.ch/${usr.handle}" class="tb-user__handle" target="_blank">@${usr.handle}</a>
                    <h5 class="tb-user__name">${usr.name}</h5>
                </div>
                <a href="#" class="button button--primary list-cta" data-action="${action_target}" data-id="${usr.id}">${action}</a>
            </div>`;
          })
          .join("")}
        </div>
    `;
};
